// removed by extract-text-webpack-plugin
module.exports = {"cmodal-title":"cmodal-title","dna-icon":"dna-icon","ant-modal-header":"ant-modal-header","ant-modal-close":"ant-modal-close","no-footer":"no-footer","ant-modal-body":"ant-modal-body"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/CModalNoFooter/Index.scss
// module id = 915
// module chunks = 0